import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CircularProgress, DialogContent, DialogTitle, Dialog } from '@mui/material';

const ContractDialog = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState(null);
    const [fileURL, setFileURL] = useState();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/suratPermohonanDomisiliVOfromDB`,{
            id
        },{
            responseType: "blob" 
        }).then(resp => {
            console.log(resp)
                const blob = new Blob([resp.data], { type: 'application/pdf' })
            // saveAs(blob);
            var fileURLNew = URL.createObjectURL(blob);
            console.log(fileURLNew)
            setLoading(false);
            window.open(fileURLNew, '_blank');
            setFileURL(fileURLNew)
        })
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Dialog open={true}>
      <DialogTitle>Contract</DialogTitle>
      <DialogContent>
      {loading ? <CircularProgress /> : <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>}
      </DialogContent>
    </Dialog>
  );
};

export default ContractDialog;
